<script>
  import ButtonPlay from "./ButtonPlay.svelte";
  import { getContext } from "svelte";
  let { currentYear } = getContext("bga-race");

  export let start;
  export let end;
  export let step;

  // Generate our list of years to build the years
  let years = generateYears();

  // For the play animation
  let timer;

  // How fast to animate each step
  const ANIMATION_INTERVAL = 2000;

  // Monitor the play state.
  let playing = false;

  // generateYears | Returns an array of
  function generateYears() {
    let retval = [];
    for (let y = start; y <= end; y += step) {
      retval.push(`${y}`);
    }
    return retval;
  }

  function handleClick(e) {
    // Switch the current year to the clicked/selected year
    $currentYear = this.dataset.year;
  }

  // play | starts at the beginning and cycles through the available years
  // by switching the store value `currentYear`, the map also will
  // cycle through the available data
  function play(e) {
    if (!playing) {
      // If not playing, then start playing
      playing = true;
      $currentYear = start;
      timer = setInterval(() => {
        $currentYear += step;
        if ($currentYear === end) {
          clearInterval(timer);
          playing = false;
        }
      }, ANIMATION_INTERVAL);
    } else {
      // If playing, then stop playing.
      playing = false;
      clearInterval(timer);
    }
  }
</script>

<div class="timeline-wrapper">
  <span id="timeline-label" class="bga-race-ui-label">Select a year</span>
  <ol aria-labelledby="timeline-label" class="timeline timeline--compressed">
    {#each years as year, i}
      <li>
        <button
          class="timeline__button"
          aria-label="View data for the year {year}"
          title="View data for the year {year}"
          data-year={year}
          class:timeline__button--active={year == $currentYear}
          on:click={handleClick}
        >
          <span class="timeline__button__circle" />
          <span class="timeline__button__year">{year}</span>
        </button>
      </li>
    {/each}
  </ol>
  <ButtonPlay on:click={play} {playing} label="Click here to animate the data over time" />
</div>

<style>
  /* STRUCTURE */

  .timeline-wrapper {
    --play-btn-extra: 12px;
    --dot-height: 22px;
    --line-z-index: 1;
    --button-width: 44px;
    --button-height: 44px;

    margin: 0 0 0.25em 0;

    display: grid;
    grid-gap: 16px;
    gap: 0.25em 16px;
    grid-template: auto / 1fr 44px;
  }

  .bga-race-ui-label {
    margin: 0;
    padding: 0;

    grid-row: 1;
    grid-column: 1/-1;
  }

  /* DOTS */
  .timeline {
    /* Import b/c of conflicts with WP theme styling */
    list-style: none;
    margin: 0 !important;
    padding: 0 !important;

    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;

    transform: translateY(calc(var(--dot-height) / 2));
  }
  .timeline.timeline--compressed {
    --button-width: 35px;
  }

  .timeline li {
    flex: 1 1;
  }

  .timeline::before {
    /* THIS IS THE LINE OF TIME */
    content: "";
    display: block;
    width: 100%;
    height: var(--line-width, 4px);
    background: var(--color-accent);
    border-radius: var(--line-width, 4px);

    position: absolute;
    top: calc(var(--dot-height) / 2);
    left: 0;
    transform: translate(0, -50%);
  }

  .timeline__button {
    display: block;

    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;

    border: none;
    background: none;
    padding: 0;
    margin: 0;
    height: var(--button-height);
    width: var(--button-width);

    cursor: pointer;
  }

  .timeline__button__year {
    font: bold 14px/1.3em var(--fonts-sans);
    color: var(--color-text);
    text-transform: uppercase;

    text-align: center;
    z-index: calc(var(--line-z-index, 1) + 1);
    position: relative;
    margin-top: 4px;
  }

  .timeline__button__circle {
    /* THIS IS THE DOT */
    display: block;
    width: var(--dot-height);
    height: var(--dot-height);
    min-width: var(--dot-height);
    min-height: var(--dot-height);

    box-sizing: border-box;
    z-index: calc(1 + var(--line-z-index));

    border: var(--line-width, 4px) solid var(--color-accent);
    background: var(--color-background);
    border-radius: 50px;
    margin: 0 auto;
    transition: background 150ms ease;
  }

  .timeline__button:focus .timeline__button__circle,
  .timeline__button:hover .timeline__button__circle {
    background: var(--color-accent);
  }

  .timeline__button.timeline__button--active .timeline__button__year {
    font-weight: bold;
    color: var(--color-accent);
  }
  .timeline__button.timeline__button--active .timeline__button__circle {
    background: var(--color-accent);
  }
</style>
